import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource-variable/fredoka";
import "@fontsource/poppins/latin-400.css";
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-700.css";
import App from "./App";
import "./index.css";

// Subdominio aplicar.* → redirigir a /aplicar (que tiene HTML prerenderizado correcto)
if (
  typeof window !== "undefined" &&
  window.location.hostname.startsWith("aplicar.") &&
  window.location.pathname === "/"
) {
  window.location.replace("/aplicar" + window.location.search + window.location.hash);
}

const container = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

const hasHydratableMarkup = Array.from(container.childNodes).some((node) => {
  if (node.nodeType === Node.COMMENT_NODE) return false;
  if (node.nodeType === Node.TEXT_NODE) return Boolean(node.textContent?.trim());
  return true;
});

if (hasHydratableMarkup) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// El <meta name="description"> estático de index.html es solo una fallback para
// crawlers que no ejecutan JS. Cuando Helmet ya puso la descripción propia de la
// página, se quita la estática para que no queden dos en el <head>.
if (typeof document !== "undefined") {
  const dropFallbackDescription = () => {
    const fallback = document.querySelector('meta[name="description"][data-fallback]');
    if (!fallback) return true;
    if (document.querySelectorAll('meta[name="description"]').length > 1) {
      fallback.remove();
      return true;
    }
    return false;
  };

  if (!dropFallbackDescription()) {
    const observer = new MutationObserver(() => {
      if (dropFallbackDescription()) observer.disconnect();
    });
    observer.observe(document.head, { childList: true });
    setTimeout(() => observer.disconnect(), 5000);
  }
}
